import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';
import { MedicalCalculator } from '../../../model/medical-calculator/medical-calculator';
import { IRootState } from '../../../reducer';
import MedicalCalculatorService from '../../../services/medical-calculator.service';
import './components.scss';

interface Props extends RouteComponentProps<{}> {
    t: (path: string, param?: any) => string;
    history: any;
}

const FreeCalculators = (props: Props) => {
    const [calculators, setCalculators] = useState<MedicalCalculator[]>([]);

    useEffect(() => {
        MedicalCalculatorService.getAvailableForFree()
            .then(response => setCalculators(response));
    }, []);

    return (
        <div className="component">
            <h1 className="component__title">{props.t('preferences.freeCalculatorsComponent.title')}</h1>
            <div className="component__content">
                {calculators && calculators.map((it, index) => (
                    <a key={index} className="component__card-item" href={`/calculator/${it.id}`}>
                        <div className="component__card-item__content">
                            <div className="component__card-item__content__row">
                                <span className="component__card-item__label">{it.name}</span>
                                <div className="arrow-right-img" />
                            </div>
                        </div>
                        <div className="component__card-item__extension" />
                    </a>
                ))}
            </div>
        </div>
    );
}

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = {};

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(FreeCalculators) as React.ComponentType<any>;
